export default __webpack_public_path__ + "ceaf128ba71eb3778af46512f18104c2.ttf";